// @ts-nocheck
import { Routes, Route } from 'react-router-dom';
import CorePage from './CorePage';
import DataDisplayPage from './DataDisplayPage';
import FeedbackPage from './FeedbackPage';
import InputsPage from './InputsPage';
import NavigationPage from './NavigationPage';
import OverlaysPage from './OverlaysPage';
import LayoutPage from './LayoutPage';
import AlertsPage from './AlertsPage';
import SwitchersPage from './SwitchersPage';
import ProvidersPage from './ProvidersPage';
import ExtrasPage from './ExtrasPage';
import AccessibilityComponentsPage from './AccessibilityComponentsPage';

export default function UIRoutes() {
  return (
    <Routes>
      <Route path="core" element={<CorePage />} />
      <Route path="data-display" element={<DataDisplayPage />} />
      <Route path="feedback" element={<FeedbackPage />} />
      <Route path="alerts" element={<AlertsPage />} />
      <Route path="inputs" element={<InputsPage />} />
      <Route path="navigation" element={<NavigationPage />} />
      <Route path="overlays" element={<OverlaysPage />} />
      <Route path="layout" element={<LayoutPage />} />
      <Route path="switchers" element={<SwitchersPage />} />
      <Route path="providers" element={<ProvidersPage />} />
      <Route path="extras" element={<ExtrasPage />} />
      <Route path="accessibility-components" element={<AccessibilityComponentsPage />} />
    </Routes>
  );
}
